// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%236B7280%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/Billing.css */

/* Page Background */
.billing-page .page-container {
  background: var(--gradient-hero); /* Light pinkish gradient */
  padding-top: var(--navbar-height);
  min-height: calc(100vh - var(--navbar-height));
  padding-bottom: 4rem;
}

.billing-page .container {
  max-width: 1000px; /* Slightly wider for better spacing */
}

/* Main Grid Container */
.billing-cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); /* Responsive columns */
  gap: 2rem;
  margin-top: 3rem;
  align-items: stretch; /* Ensures cards are same height */
}

/* Card Styling */
.billing-card {
  background: var(--bg-primary); /* White */
  border: 1px solid var(--border-primary); /* Light Gray */
  border-radius: 20px; /* Modern rounded corners */
  padding: 2.5rem;
  box-shadow: var(--shadow-xl); /* Soft shadow to lift off page */
  display: flex;
  flex-direction: column; /* Stack content vertically */
  transition: transform 0.3s ease;
  position: relative;
  overflow: hidden;
}

.billing-card:hover {
  transform: translateY(-5px);
  border-color: var(--border-accent);
}

/* Top Border Accent (Optional aesthetic touch) */
.billing-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--gradient-button);
}

.billing-card h3 {
  color: var(--text-primary);
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-align: center; /* Center the header */
  letter-spacing: -0.5px;
}

/* Strict Grid for Details */
.plan-details-grid {
  display: grid;
  grid-template-columns: 1fr auto; /* Label takes space, value takes what it needs */
  row-gap: 1.2rem; /* Vertical spacing between rows */
  column-gap: 1.5rem; /* Gap between Label and Value */
  margin-bottom: 2rem;
  font-size: 1rem;
}

/* Labels (Left side) */
.plan-details-grid strong {
  color: var(--text-secondary); /* Muted color for labels */
  font-weight: 500;
  text-align: left;
}

/* Values (Right side) */
.plan-details-grid span {
  color: var(--text-primary); /* Dark color for values */
  font-weight: 600;
  text-align: right;
}

/* Specific style for the red number */
.plan-details-grid .plan-remaining {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-accent); /* Red */
}

/* Card Footer / Actions */
.billing-card-actions {
  margin-top: auto; /* Pushes button to the very bottom */
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-primary); /* Separator line */
  text-align: center;
}

/* Consistent Button Styling */
.billing-card .submit-button {
  width: 100%; /* Full width button */
  justify-content: center;
  padding: 0.9rem;
  font-size: 1rem;
  box-shadow: var(--shadow-lg);
}

/* Invoice Section Styling */
.invoice-description {
  color: var(--text-secondary);
  font-size: 0.95rem;
  margin-bottom: 2rem;
  text-align: center;
  line-height: 1.6;
}

.invoice-history-list {
  flex-grow: 1; /* Takes up available space */
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* The Invoice Row Item */
.invoice-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem;
  background: var(--bg-secondary); /* Very light gray background */
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  transition: all 0.2s ease;
}

.invoice-item:hover {
  background: white;
  border-color: var(--text-accent);
  box-shadow: var(--shadow-lg);
}

.invoice-details {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.invoice-details strong {
  color: var(--text-primary);
  font-weight: 600;
  font-size: 1rem;
}

.invoice-details span {
  color: var(--text-secondary);
  font-size: 0.85rem;
  margin-top: 0.2rem;
}

/* Adjust download button inside the row */
.invoice-item .submit-button {
  width: auto; /* Auto width inside the row */
  padding: 0.6rem 1.5rem;
  font-size: 0.9rem;
  min-width: 120px;
}

/* --- RECTIFIED: NEW STYLES FOR TOP-UP PAGE --- */
.top-up-select {
  width: 100%;
  padding: 0.8rem 1rem;
  border: 1px solid var(--border-primary);
  border-radius: 12px; /* Rounded modern look */
  background-color: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  /* Custom arrow */
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem top 50%;
  background-size: 0.8rem auto;
}

.top-up-select:focus {
  outline: none;
  border-color: var(--text-accent);
  background-color: var(--bg-primary);
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);
}

.top-up-terms {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  margin: 1.5rem 0;
  padding: 1rem;
  background: var(--bg-secondary);
  border-radius: 12px;
  border: 1px solid var(--border-primary);
}

.top-up-terms input[type="checkbox"] {
  margin-top: 0.25rem;
  width: 18px;
  height: 18px;
  accent-color: var(--text-accent);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/styles/Billing.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B,oBAAoB;AACpB;EACE,gCAAgC,EAAE,2BAA2B;EAC7D,iCAAiC;EACjC,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,iBAAiB,EAAE,sCAAsC;AAC3D;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,2DAA2D,EAAE,uBAAuB;EACpF,SAAS;EACT,gBAAgB;EAChB,oBAAoB,EAAE,kCAAkC;AAC1D;;AAEA,iBAAiB;AACjB;EACE,6BAA6B,EAAE,UAAU;EACzC,uCAAuC,EAAE,eAAe;EACxD,mBAAmB,EAAE,2BAA2B;EAChD,eAAe;EACf,4BAA4B,EAAE,iCAAiC;EAC/D,aAAa;EACb,sBAAsB,EAAE,6BAA6B;EACrD,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB,EAAE,sBAAsB;EAC1C,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,+BAA+B,EAAE,iDAAiD;EAClF,eAAe,EAAE,kCAAkC;EACnD,kBAAkB,EAAE,gCAAgC;EACpD,mBAAmB;EACnB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,4BAA4B,EAAE,2BAA2B;EACzD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,0BAA0B,EAAE,0BAA0B;EACtD,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB,EAAE,QAAQ;AACrC;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB,EAAE,qCAAqC;EACvD,mBAAmB;EACnB,2CAA2C,EAAE,mBAAmB;EAChE,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,WAAW,EAAE,sBAAsB;EACnC,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY,EAAE,6BAA6B;EAC3C,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,+BAA+B,EAAE,+BAA+B;EAChE,uCAAuC;EACvC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,WAAW,EAAE,8BAA8B;EAC3C,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,oBAAoB;EACpB,uCAAuC;EACvC,mBAAmB,EAAE,wBAAwB;EAC7C,qCAAqC;EACrC,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,yDAAof;EACpf,4BAA4B;EAC5B,uCAAuC;EACvC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,eAAe;AACjB","sourcesContent":["/* src/styles/Billing.css */\n\n/* Page Background */\n.billing-page .page-container {\n  background: var(--gradient-hero); /* Light pinkish gradient */\n  padding-top: var(--navbar-height);\n  min-height: calc(100vh - var(--navbar-height));\n  padding-bottom: 4rem;\n}\n\n.billing-page .container {\n  max-width: 1000px; /* Slightly wider for better spacing */\n}\n\n/* Main Grid Container */\n.billing-cards-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr)); /* Responsive columns */\n  gap: 2rem;\n  margin-top: 3rem;\n  align-items: stretch; /* Ensures cards are same height */\n}\n\n/* Card Styling */\n.billing-card {\n  background: var(--bg-primary); /* White */\n  border: 1px solid var(--border-primary); /* Light Gray */\n  border-radius: 20px; /* Modern rounded corners */\n  padding: 2.5rem;\n  box-shadow: var(--shadow-xl); /* Soft shadow to lift off page */\n  display: flex;\n  flex-direction: column; /* Stack content vertically */\n  transition: transform 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.billing-card:hover {\n  transform: translateY(-5px);\n  border-color: var(--border-accent);\n}\n\n/* Top Border Accent (Optional aesthetic touch) */\n.billing-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--gradient-button);\n}\n\n.billing-card h3 {\n  color: var(--text-primary);\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  text-align: center; /* Center the header */\n  letter-spacing: -0.5px;\n}\n\n/* Strict Grid for Details */\n.plan-details-grid {\n  display: grid;\n  grid-template-columns: 1fr auto; /* Label takes space, value takes what it needs */\n  row-gap: 1.2rem; /* Vertical spacing between rows */\n  column-gap: 1.5rem; /* Gap between Label and Value */\n  margin-bottom: 2rem;\n  font-size: 1rem;\n}\n\n/* Labels (Left side) */\n.plan-details-grid strong {\n  color: var(--text-secondary); /* Muted color for labels */\n  font-weight: 500;\n  text-align: left;\n}\n\n/* Values (Right side) */\n.plan-details-grid span {\n  color: var(--text-primary); /* Dark color for values */\n  font-weight: 600;\n  text-align: right;\n}\n\n/* Specific style for the red number */\n.plan-details-grid .plan-remaining {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-accent); /* Red */\n}\n\n/* Card Footer / Actions */\n.billing-card-actions {\n  margin-top: auto; /* Pushes button to the very bottom */\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--border-primary); /* Separator line */\n  text-align: center;\n}\n\n/* Consistent Button Styling */\n.billing-card .submit-button {\n  width: 100%; /* Full width button */\n  justify-content: center;\n  padding: 0.9rem;\n  font-size: 1rem;\n  box-shadow: var(--shadow-lg);\n}\n\n/* Invoice Section Styling */\n.invoice-description {\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  line-height: 1.6;\n}\n\n.invoice-history-list {\n  flex-grow: 1; /* Takes up available space */\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n/* The Invoice Row Item */\n.invoice-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.2rem;\n  background: var(--bg-secondary); /* Very light gray background */\n  border: 1px solid var(--border-primary);\n  border-radius: 12px;\n  transition: all 0.2s ease;\n}\n\n.invoice-item:hover {\n  background: white;\n  border-color: var(--text-accent);\n  box-shadow: var(--shadow-lg);\n}\n\n.invoice-details {\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n\n.invoice-details strong {\n  color: var(--text-primary);\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.invoice-details span {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  margin-top: 0.2rem;\n}\n\n/* Adjust download button inside the row */\n.invoice-item .submit-button {\n  width: auto; /* Auto width inside the row */\n  padding: 0.6rem 1.5rem;\n  font-size: 0.9rem;\n  min-width: 120px;\n}\n\n/* --- RECTIFIED: NEW STYLES FOR TOP-UP PAGE --- */\n.top-up-select {\n  width: 100%;\n  padding: 0.8rem 1rem;\n  border: 1px solid var(--border-primary);\n  border-radius: 12px; /* Rounded modern look */\n  background-color: var(--bg-secondary);\n  color: var(--text-primary);\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  /* Custom arrow */\n  appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%236B7280%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1rem top 50%;\n  background-size: 0.8rem auto;\n}\n\n.top-up-select:focus {\n  outline: none;\n  border-color: var(--text-accent);\n  background-color: var(--bg-primary);\n  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1);\n}\n\n.top-up-terms {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.8rem;\n  margin: 1.5rem 0;\n  padding: 1rem;\n  background: var(--bg-secondary);\n  border-radius: 12px;\n  border: 1px solid var(--border-primary);\n}\n\n.top-up-terms input[type=\"checkbox\"] {\n  margin-top: 0.25rem;\n  width: 18px;\n  height: 18px;\n  accent-color: var(--text-accent);\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
